import type { AxiosInstance } from 'axios';
import { getOnStorage } from './storageFunctions';
import { forceSessionExpiredLogout, isUnauthorizedAxiosError } from './sessionAuth';

const getAwsAuthHeader = () => {
  const token = getOnStorage('temporary_token_aws') || getOnStorage('token_aws');
  return token ? `Bearer ${token}` : '';
};

export const attachSessionInterceptors = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use((config) => {
    config.headers.Authorization = getAwsAuthHeader();
    return config;
  });

  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.config?.disableInterceptor) {
        return Promise.reject(error);
      }

      if (isUnauthorizedAxiosError(error) && hasActiveSessionGuard()) {
        void forceSessionExpiredLogout();
      }

      return Promise.reject(error);
    }
  );

  return axiosInstance;
};

const hasActiveSessionGuard = () => {
  return Boolean(getOnStorage('token_magento') || getOnStorage('token_aws') || getOnStorage('temporary_token_aws'));
};
